import { PostalAddress } from '../../../common/model/postal-address';
import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';
import { Money } from '../../../core/model/money';

export class TransferSeller extends ModelBase {
  constructor(model?: any) {
    super();
    if (model) {
      this.id = model.id;
      this.contactId = model.contactId;
      this.ownedShare = model.ownedShare;
      this.soldShare = model.soldShare;
      this.name = model.name;
      this.email = model.email;
      this.phone = model.phone;
      this.companyAmortization_636 = model.companyAmortization_636;
      this.buyAmount_643 = model.buyAmount_643;
      this.buyDate_640 = LocalDate.fromDate(model.buyDate_640);
      this.innerFundBuy_644 = model.innerFundBuy_644;
      this.ownerAmortization_636 = model.ownerAmortization_636;
      this.postalAddress = model.postalAddress;
      this.memberFrom = LocalDate.fromDate(model.memberFrom);
      this.membershipApproved = LocalDate.fromDate(model.membershipApproved);
      this.memberTo = LocalDate.fromDate(model.memberTo);
      this.acquisitionGiftOrInheritance_642 = model.acquisitionGiftOrInheritance_642;
    }
  }

  contactId: string;
  ownedShare: number;
  soldShare: number;
  name: string;
  email: string;
  phone: string;
  companyAmortization_636: Money;
  buyDate_640: LocalDate;
  buyAmount_643: Money;
  innerFundBuy_644: Money;
  ownerAmortization_636: Money;
  postalAddress: PostalAddress;
  memberFrom: LocalDate;
  membershipApproved: LocalDate;
  memberTo: LocalDate;
  acquisitionGiftOrInheritance_642: boolean;
}
